import React, { useCallback } from "react";

import { faChevronDown } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row } from "antd";
import { useSlate } from "slate-react";

import { stopEvents } from "@mapmycustomers/shared/util/browser";

import Dropdown from "../../../../Dropdown";
import ElementType from "../../../../type/slate/ElementType";
import { ElementControl } from "../../type/Control";
import findMatchedElementTypes from "../../util/findMatchedElementTypes";
import toggleBlock from "../../util/toggleBlock";
import ToggleButton from "../ToggleButton";

import ActionTooltipWrapper from "./ActionTooltipWrapper";

interface ElementTogglerProps {
  dropdownElement?: React.ReactNode;
  tooltipTranslationString: string;
  value: ElementControl | ElementControl[];
}

const ElementToggler = ({
  dropdownElement,
  tooltipTranslationString,
  value,
}: ElementTogglerProps) => {
  const editor = useSlate();

  const handleToggleBlock = useCallback(
    (type: ElementType) => {
      toggleBlock(editor, type);
    },
    [editor]
  );

  if (Array.isArray(value)) {
    return (
      <Dropdown
        menu={{
          items: value.map(({ label, value }) => ({
            key: value,
            label,
          })),
          onClick: (e) => handleToggleBlock(e.key as ElementType),
          onMouseDown: stopEvents,
        }}
        placement="top"
        trigger={["click"]}
      >
        <ActionTooltipWrapper translationString={tooltipTranslationString}>
          <ToggleButton>
            <Row align="middle" gutter={4}>
              <Col>{dropdownElement}</Col>
              <Col>
                <FontAwesomeIcon icon={faChevronDown} size="xs" />
              </Col>
            </Row>
          </ToggleButton>
        </ActionTooltipWrapper>
      </Dropdown>
    );
  }
  return (
    <ActionTooltipWrapper translationString={tooltipTranslationString}>
      <ToggleButton
        active={findMatchedElementTypes(editor, value.value)[0]}
        onClick={() => handleToggleBlock(value.value)}
      >
        {value.label}
      </ToggleButton>
    </ActionTooltipWrapper>
  );
};

export default ElementToggler;
